import axios from 'axios';
import qs from 'qs';

axios.defaults.withCredentials = true;
export const ApiCall = (endPoint, data, withCredentials = true) => {
  const URI = `${process.env.REACT_APP_API_URL}${endPoint}`;
  return axios.post(URI, qs.stringify(data), {});
};

export const ApiPostFile = (endPoint, data) => {
  const URI = `${process.env.REACT_APP_API_URL}${endPoint}`;
  return axios.post(URI, data, {});
};

export default ApiCall;
